import React from 'react';
import classNames from 'classnames';
import { ColorType, IconType } from '../icon/EMIcon';

export interface PButtonProps extends React.DOMAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  type: 'primary' | 'secondary' | 'sm' | 'link' | 'inline' | 'icon';
  color?: 'primary' | 'sub-title';
  className?: string;
  icon?: IconType;
  id?: string;
  disabled?: boolean;
  active?: boolean;
  iconColor?: ColorType;
  style?: React.CSSProperties;
  isSubmit?: boolean;
}

export function EMButton({
  isLoading,
  type,
  children,
  className,
  icon,
  id,
  color,
  active,
  iconColor,
  isSubmit = false,
  ...props
}: React.PropsWithChildren<PButtonProps>): React.FunctionComponentElement<PButtonProps> {
  const buttonProps = {
    ...props,
    id,
    className: classNames(
      `${type === 'icon' ? '' : 'btn'} btn-${type}`,
      `${color ? 'color-' + color : ''}`,
      {
        loading: isLoading,
      },
      {
        active: active,
      },
      className
    ),
  };
  return (
    <button {...buttonProps} id={id} style={buttonProps.style} type={isSubmit ? "submit" : "button"}>
      {isLoading && <i className="icon-loading spinner"></i>}
      {icon && (
        <i
          className={`icon-${icon} ${
            color ? 'color-' + color : iconColor ? 'color-' + iconColor : ''
          }`}
        />
      )}
      {children}
    </button>
  );
}
